import React from "react"

import styles from "./hero-simple.module.css"

export default function HeroSimple({ children }) {
  return <div className={styles.heroSimple}>{children}</div>
}
